import { ChapterItem } from "src/components/RenderChapter/types";
import { privacyPolicyTrns } from "./trns";

const CLASSNAME_TITLE_LEVEL_1 = "font-monument-extended font-semibold text-2xl";
const CLASSNAME_TITLE_LEVEL_2 = "font-bold text-xl";

const CLASSNAME_LIST_DESC = "list-disc pl-5";
const CLASSNAME_LIST_WITHOUT_DESC = "flex flex-col gap-7";

export const PRIVACY_POLICY_CONTENT: ChapterItem[] = [
  {
    id: "Introduction",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.introductionTitle,
      },
    },
    contentFirst:
      'This Privacy Policy describes how "Business Clone" (hereinafter referred to as "we," "us," "our") collects, uses, and protects the personal information of users (hereinafter referred to as "user," "you," "your") of our website and services. We understand the importance of your data privacy and are committed to protecting your privacy. In this document, we explain how we collect, use, store, and disclose your information.',
  },
  {
    id: "Information Collection",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.informationCollectionTitle,
      },
    },
    subsections: [
      {
        id: "Personal Information",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.personalInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Personal Information 1",
              item: "Name and Surname: For user identification.",
            },
            {
              id: "Personal Information 2",
              item: "Email Address: For communication and notifications.",
            },
            {
              id: "Personal Information 3",
              item: "Phone Number: For quick contact and identity verification.",
            },
            {
              id: "Personal Information 4",
              item: "Residential or Registration Address: To determine the location of service provision and possible legal requirements.",
            },
            {
              id: "Personal Information 5",
              item: "Date of Birth: To confirm the user's age if necessary.",
            },
            {
              id: "Personal Information 6",
              item: "Identification Documents: Copies of passports or other identification documents for identity verification.",
            },
          ],
        },
      },
      {
        id: "Financial Information",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.financialInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Financial Information 1",
              item: "Payment Card Data: Card number, expiration date, CVV code for payment processing.",
            },
            {
              id: "Financial Information 2",
              item: "Bank Accounts: Information about bank accounts for fund transfers.",
            },
            {
              id: "Financial Information 3",
              item: "Phone Number: For quick contact and identity verification.",
            },
          ],
        },
      },
      {
        id: "Technical Information",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.technicalInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Technical Information 1",
              item: "IP Address: To identify the user and ensure security.",
            },
            {
              id: "Technical Information 2",
              item: "Browser Type and Version: To optimize the website’s performance for specific browsers.",
            },
            {
              id: "Technical Information 3",
              item: "Browser Language: To provide content in the appropriate language.",
            },
            {
              id: "Technical Information 4",
              item: "Date and Time of Visits: For analytics and website improvement.",
            },
            {
              id: "Technical Information 5",
              item: "Pages Viewed: To analyze user interests and optimize content.",
            },
            {
              id: "Technical Information 6",
              item: "Cookies and Similar Technologies: To save user settings and track their activity on the site.",
            },
          ],
        },
      },
      {
        id: "Other Information",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.otherInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Other Information 1",
              item: "Company Data:",
              list: {
                className: CLASSNAME_LIST_DESC,
                items: [
                  {
                    id: "Other Information 1.1.",
                    item: "Company Name: To identify the company on the platform.",
                  },
                  {
                    id: "Other Information 1.2.",
                    item: "Company Reviews: Client and partner reviews that help assess the company's reputation.",
                  },
                  {
                    id: "Other Information 1.3.",
                    item: "Advertising Materials: Information about marketing campaigns, advertising videos, banners, and other materials used to promote the company.",
                  },
                  {
                    id: "Other Information 1.4.",
                    item: "Financial Reports: Annual reports, balances, profit and loss statements provided to assess the company's financial condition.",
                  },
                  {
                    id: "Other Information 1.5.",
                    item: "Company Profiles on Various Sites: Information from the company's profiles on other internet resources such as social networks, business directories, rating platforms.",
                  },
                ],
              },
            },
            {
              id: "Other Information 2",
              item: "Business Models: Description of the business models used in your company.",
            },
            {
              id: "Other Information 3",
              item: "Technological Processes: Description of the technologies and processes used in your company.",
            },
            {
              id: "Other Information 4",
              item: "Professional Information: Data about your professional skills, work experience, achievements, and certifications.",
            },
            {
              id: "Other Information 5",
              item: "Social Information: Social network profiles, professional contacts.",
            },
          ],
        },
      },
      {
        id: "Sources of Information Collection",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.sourcesInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Sources 1",
              item: "Forms on the Site: Information you voluntarily provide by filling out registration forms, feedback forms, or other interactive elements on our site.",
            },
            {
              id: "Sources 2",
              item: "Automatic Data Collection: We may automatically collect certain information about your equipment and interaction with our site through cookies, server logs, and other similar technologies.",
            },
            {
              id: "Sources 3",
              item: "Third Parties: We may receive information about you from third parties such as social networks, payment systems, and other partners if you have agreed to the transfer of such information.",
            },
            {
              id: "Sources 4",
              item: "Open Sources: We may receive information from other open sources or internet resources including company profiles on various sites such as business directories and social networks.",
            },
          ],
        },
      },
    ],
    contentLast:
      "We make every effort to protect your information and its confidentiality. Your information will only be used in accordance with our Privacy Policy and to provide you with our services at the highest level.",
  },
  {
    id: "Information Usage",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.informationUsageTitle,
      },
    },
    contentFirst:
      "We use the collected information for the following purposes:",
    subsections: [
      {
        id: "Service Provision",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.serviceProvisionTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Service Provision 1",
              item: "Registration Processing: We use your personal information to create and maintain your account on our platform, including verifying your identity and ensuring an appropriate level of security.",
            },
            {
              id: "Service Provision 2",
              item: "User Profile Creation: The information you provide helps us create your profile that contains basic information about you, your company, and your business processes. This allows other users to find and contact you.",
            },
            {
              id: "Service Provision 3",
              item: "Order Management: We use your financial information to process payments, manage transactions, and ensure the fulfillment of your orders on the platform.",
            },
            {
              id: "Service Provision 4",
              item: "Service Provision: Information about your business allows us to tailor our services to your needs, including providing support, consulting, and access to additional services.",
            },
          ],
        },
      },
      {
        id: "Improvement of Our Website",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.websiteImprovementTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Improvement of Our Website 1",
              item: "Site Usage Analysis: We collect technical information about site visits to analyze user behavior, identify popular pages, and determine problem areas.",
            },
            {
              id: "Improvement of Our Website 2",
              item: "Functionality Optimization: Based on the collected data, we improve the design and functionality of the site to ensure a more convenient and efficient user experience.",
            },
            {
              id: "Improvement of Our Website 3",
              item: "Testing New Features: We may use your information to test new features and services to ensure they meet your needs and expectations.",
            },
          ],
        },
      },
      {
        id: "Communication",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.communicationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Communication 1",
              item: "Sending Updates: We may use your contact information to inform you about important platform updates, changes in the privacy policy, or other terms of use.",
            },
            {
              id: "Communication 2",
              item: "Marketing Materials: We may send you news, offers, and promotional materials that may interest you. You can unsubscribe from receiving such messages at any time by using the unsubscribe link in each email.",
            },
            {
              id: "Communication 3",
              item: "Responding to Inquiries: Your information is used to respond to your inquiries, provide support, and resolve issues you may encounter while using our site or services.",
            },
          ],
        },
      },
      {
        id: "Rights and Security Protection",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.rightsSecurityTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Rights and Security Protection 1",
              item: "Fraud Prevention: We use your information to detect and prevent fraudulent activities, ensure the security of your account, and protect our systems and users.",
            },
            {
              id: "Rights and Security Protection 2",
              item: "Legal Compliance: We may process your information to comply with legal requirements, court orders, and other legal processes.",
            },
            {
              id: "Rights and Security Protection 3",
              item: "Data Security: We take technical and organizational measures to protect your information from unauthorized access, loss, alteration, or disclosure.",
            },
          ],
        },
      },
    ],
  },
  {
    id: "Information Disclosure",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.informationDisclosureTitle,
      },
    },
    contentFirst:
      "We may disclose personal information in the following cases:",
    subsections: [
      {
        id: "You Give Consent",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.consentTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "You Give Consent 1",
              item: "By agreeing to our company's privacy policy, you consent to the disclosure of available information about you, your company, services, and other details highlighted or mentioned on our resources.",
            },
            {
              id: "You Give Consent 2",
              item: "By agreeing to our company's privacy policy, you consent to the disclosure of all available information about you, for example, for data transfer to other services or partners with whom we cooperate within the framework of our service's advertising campaigns and others that we consider effective and beneficial for your and our business.",
            },
          ],
        },
      },
      {
        id: "Business Partners",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.businessPartnersTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Business Partners 1",
              item: "Payment Processing Services: We may provide your financial information to partners who process payments to ensure secure and efficient financial transactions.",
            },
            {
              id: "Business Partners 2",
              item: "Technical Support: We may transfer your information to companies that provide technical support and maintenance of our platform to ensure smooth site operation and resolve technical issues.",
            },
            {
              id: "Business Partners 3",
              item: "Marketing Partners: We may collaborate with marketing agencies and partners to conduct advertising campaigns and promote our services. Your contact details may be used to send you marketing materials if you have consented to this.",
            },
          ],
        },
      },
      {
        id: "Legal Requirements",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.legalRequirementsTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Legal Requirements 1",
              item: "Legal Compliance: We may disclose your information to comply with laws, regulations, court orders, or other legal processes, including investigations and requests from law enforcement authorities.",
            },
            {
              id: "Legal Requirements 2",
              item: "Rights Protection: We may disclose your information to protect our rights, property, or safety, as well as the rights, property, or safety of our users or others. This may include sharing information with other companies and organizations for fraud prevention and credit risk reduction.",
            },
            {
              id: "Legal Requirements 3",
              item: "Legal Processes: We may use your information within legal processes such as court cases, arbitration procedures, or administrative proceedings if necessary to protect our interests or fulfill legal obligations.",
            },
          ],
        },
      },
      {
        id: "Service Providers",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.serviceProvidersTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Service Providers 1",
              item: "Payment Systems: We may transfer your information to payment system providers to process your financial transactions.",
            },
            {
              id: "Service Providers 2",
              item: "Hosting and IT Services: We may provide access to your information to companies that provide hosting services, data storage, support, and maintenance of our IT infrastructure",
            },
            {
              id: "Service Providers 3",
              item: "Analytical Services: We may collaborate with analytical companies to analyze data on the use of our site, which helps us improve our services and better understand user needs.",
            },
          ],
        },
      },
      {
        id: "Aggregated and Anonymized Information",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.aggregatedInformationTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Aggregated and Anonymized Information 1",
              item: "Research and Analytics: We may use aggregated and anonymized information for research, analytics, reporting, and other commercial purposes. This information does not contain personal data and does not allow identifying individual users.",
            },
          ],
        },
      },
      {
        id: "Sale or Merger of the Company",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.companySaleTitle,
          },
        },
        list: {
          className: CLASSNAME_LIST_DESC,
          items: [
            {
              id: "Sale or Merger of the Company 1",
              item: "Mergers and Acquisitions: In the event of a sale, merger, or reorganization of our company, we may transfer your information to the new owner or combined company. In such a case, we will ensure the protection of your information in accordance with this Privacy Policy and notify you of any changes in ownership or use of your personal data.",
            },
          ],
        },
      },
    ],
    contentLast:
      "This section details the cases and purposes for which we may disclose your personal information to third parties, ensuring an appropriate level of protection and confidentiality of your data.",
  },
  {
    id: "Information Protection",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.informationProtectionTitle,
      },
    },
    contentFirst:
      "We use appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. We apply physical, technical, and administrative security measures to protect your information.",
  },
  {
    id: "Your Rights Regarding Personal Information",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.personalRightsTitle,
      },
    },
    contentFirst:
      "Access to Information: You have the right to access the personal information we hold about you. You can request a copy of this information by contacting us through the contact information on our site.",
    list: {
      className: CLASSNAME_LIST_WITHOUT_DESC,
      items: [
        {
          id: "Your Rights Regarding Personal Information 1",
          item: "Data Correction: You have the right to request the correction of any inaccuracies in your personal information. If you find that any information we hold about you is incorrect or outdated, please inform us.",
        },
        {
          id: "Your Rights Regarding Personal Information 2",
          item: "Data Deletion: You have the right to request the deletion of your personal information in cases provided by law. This includes the right to be forgotten when the information is no longer needed for the purposes for which it was collected or when you withdraw your consent for its processing.",
        },
        {
          id: "Your Rights Regarding Personal Information 3",
          item: "Processing Restriction: You have the right to request the restriction of the processing of your personal information in certain cases, such as when you dispute the accuracy of the data or object to its processing.",
        },
        {
          id: "Your Rights Regarding Personal Information 4",
          item: "Data Portability: You have the right to receive your personal information in a structured, commonly used, and machine-readable format and to transfer this data to another controller.",
        },
      ],
    },
    contentLast:
      "You can view, review, and change most of your personal information by logging into the Resource/Platform. You should promptly update your personal information if it changes or is inaccurate. Once you have made a public announcement, you will not be able to change or delete it. If you deactivate your account, your profile page (with a notice that your account has been deactivated) will still be visible, and all posted content will remain accessible. In addition to the above, we retain personal information from closed accounts to the extent required by applicable law (including to comply with laws, prevent fraud, collect any due payments, resolve disputes, troubleshoot problems, assist in any investigations, and comply with our agreements related to the Resource/Platform). We have the right to perform other actions provided by law or specified in this Policy.",
  },
  {
    id: "Changes to the Privacy Policy",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.changesPolicyTitle,
      },
    },
    contentFirst:
      "We reserve the right to change this Privacy Policy at any time. To ensure transparency and inform users about our privacy practices, all changes will be posted on this page with the updated effective date. We recommend regularly reviewing this page for the latest information on our privacy practices.",
    subsections: [
      {
        id: "Process of Making Changes",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.processChangesTitle,
          },
        },
        subsections: [
          {
            id: "Identifying the Need for Changes",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.identifyingNeedChangesTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Identifying the Need for Changes 1",
                  item: "We regularly review our Privacy Policy to ensure compliance with current legislation, changes in our business processes, and technological innovations.",
                },
                {
                  id: "Identifying the Need for Changes 2",
                  item: "User feedback and suggestions are also taken into account to improve our privacy practices.",
                },
              ],
            },
          },
          {
            id: "Developing Changes",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.developingChangesTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Developing Changes 1",
                  item: "Our legal department, together with the data protection department, develops a draft of changes to the Privacy Policy, considering all necessary requirements and recommendations.",
                },
              ],
            },
          },
          {
            id: "Internal Approval",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.internalApprovalTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Internal Approval 1",
                  item: "The draft changes undergo internal approval by the company's management, including a review for compliance with legal norms and privacy requirements",
                },
              ],
            },
          },
          {
            id: "Informing Users",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.informingUsersTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Informing Users 1",
                  item: "After the changes are approved, we publish the updated Privacy Policy on this page, indicating the effective date of the new provisions.",
                },
                {
                  id: "Informing Users 2",
                  item: "We may, but are not obliged to, notify users of significant changes via email or other available means of communication.",
                },
              ],
            },
          },
        ],
      },
      {
        id: "Important Aspects of Changes",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.importantAspectsChangesTitle,
          },
        },
        subsections: [
          {
            id: "Updated Effective Date",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.updatedEffectiveDateTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Updated Effective Date 1",
                  item: "Each new version of the Privacy Policy will include an effective date, allowing users to easily track the latest changes.",
                },
              ],
            },
          },
          {
            id: "Significant Changes",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.significantChangesTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Significant Changes 1",
                  item: "In the case of significant changes that may affect your rights or the processing of your personal information, we will provide additional notification and, if necessary, obtain your consent to these changes.",
                },
              ],
            },
          },
        ],
      },
      {
        id: "Regular Review",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.regularReviewTitle,
          },
        },
        subsections: [
          {
            id: "Review Frequency",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.reviewFrequencyTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Review Frequency 1",
                  item: "We conduct a regular review of our Privacy Policy at least once a year or more frequently in the event of significant changes in legislation or our activities.",
                },
              ],
            },
          },
          {
            id: "User Feedback",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.userFeedbackTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "User Feedback 1",
                  item: "We encourage users to provide their feedback and suggestions regarding the Privacy Policy. Your opinions help us continuously improve our privacy practices.",
                },
              ],
            },
          },
        ],
      },
      {
        id: "Your Actions",
        title: {
          className: CLASSNAME_TITLE_LEVEL_2,
          label: {
            i18nKey: privacyPolicyTrns.userActionsTitle,
          },
        },
        subsections: [
          {
            id: "Regular Review",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.regularReviewActionsTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Regular Review 1",
                  item: "We recommend regularly reviewing this page to stay informed about our privacy practices. This will help you stay aware of how we protect your information.",
                },
              ],
            },
          },
          {
            id: "Inquiries and Questions",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.inquiriesQuestionsTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Inquiries and Questions 1",
                  item: "If you have any questions or concerns about our Privacy Policy, you can contact us through the contact information provided on our site.",
                },
              ],
            },
          },
          {
            id: "Consent to Changes",
            title: {
              className: CLASSNAME_TITLE_LEVEL_2,
              label: {
                i18nKey: privacyPolicyTrns.consentToChangesTitle,
              },
            },
            list: {
              className: CLASSNAME_LIST_DESC,
              items: [
                {
                  id: "Consent to Changes 1",
                  item: "Continuing to use our site and services after changes to the Privacy Policy have been posted signifies your agreement to these changes. If you do not agree with any changes, you should stop using our site and services.",
                },
              ],
            },
          },
        ],
      },
    ],
  },
  {
    id: "Additional Information",
    title: {
      className: CLASSNAME_TITLE_LEVEL_1,
      label: {
        i18nKey: privacyPolicyTrns.additionalInformationTitle,
      },
    },
    list: {
      className: CLASSNAME_LIST_WITHOUT_DESC,
      items: [
        {
          id: "Additional Information 1",
          item: "Applicability: This document only addresses the use and disclosure of information we collect from you unless otherwise expressly stated in this Policy. If you disclose information to third parties who are users of the Resource/Platform or other Internet resources, different rules may apply.",
        },
        {
          id: "Additional Information 2",
          item: "Children: The Resource is not intended for children. If you are under eighteen years old, please do not provide us with any personal information. If a person under 18 has provided us with personal information, their parents or guardian should contact us via email, and we will be able to delete such information from our database.",
        },
        {
          id: "Additional Information 3",
          item: "After the termination or deactivation of your account, we may retain your profile data and user content for commercially reasonable periods for backup, archiving, or audit purposes. In addition, Klon may retain and continue to use all information (including user content) contained in your messages to other users or posted in public or semi-public areas of the Resource after the termination or deactivation of your account.",
        },
        {
          id: "Additional Information 4",
          item: 'Your Use of the Resource: To provide your services on the Resource, your name will be displayed on the Resource and will be publicly accessible. You can change or delete your information in the personal account "My Klon" at any time.',
        },
        {
          id: "Additional Information 5",
          item: 'Use of Cookies: The Resource may use "cookies," which are small text files placed on your computer or device. We also use pixel tags, web beacons, and other similar technologies. These devices are used to help analyze our web page flow, customize our services, optimize our interfaces, measure advertising effectiveness, and build trust and security. Using these devices, we collect the following data: identification of active internet providers, user\'s IP address, browser type and operating system, date and time of access to the Resource/Platform, the web page address (if any) through which the user connected to the Resource/Platform, and other similar traffic-related information. We may also combine such information with similar data collected from other users and disclose such aggregate information to third parties. Some features are only available through the use of cookies, and generally, we need to use cookies to help identify you and maintain your registered status. You can always decline cookies on the Resource/Platform in your browser settings, although this may interfere with your use of the Resource/Platform. We may use third-party services that may contain cookies in accordance with their cookie policies.',
        },
        {
          id: "Additional Information 6",
          item: "Password: Your password deserves careful analysis and protection. Use unique numbers, letters, and special characters, and do not disclose your password to anyone. If you disclose your password or personal information to others, remember that you are responsible for all actions taken with your profile. If you lose control over your password, you may lose your personal information, and this may result in legally significant actions taken on your behalf. If your password has been compromised for any reason, you should immediately change your password in your profile on the Resource/Platform.",
        },
        {
          id: "Additional Information 7",
          item: "We may combine your information with information we receive from other sources to improve the Resource/Platform and the functionality of the offers we provide, our affiliated companies, clients, and partners. We may provide, sell, or rent anonymous (non-personalized) information about you that arises from your use of the Resource/Platform to unaffiliated third parties for marketing and other commercial purposes (e.g., any information regarding preferences, practice areas, activity areas of the Resource/Platform, location, and working habits).",
        },
        {
          id: "Additional Information 8",
          item: "Contact Information: If you have any questions or comments regarding this Privacy Policy, please contact us.",
        },
      ],
    },
  },
];
